import React from 'react'
import { Card, RenderHTML } from '../../../../../components'
import { getDetail, getAddress, getPhones, getStrategy, THEMES } from '../../../../../utils'
import { Grid } from '@material-ui/core'

/**
 * Job Detail Component
 * @param props
 * @returns {*}
 * @constructor
 */
const JobDetail = (props) => {
  const { job, strategy } = props
  const { institution_name, institution_type, phone, direct_telephone, email, title, functions } = job
  const address = getAddress(job)
  const phones = getPhones(phone, direct_telephone)

  return (
    <Grid item xs={12}>
      <Card
        title='Institution'
        theme={THEMES.DARK_SLATE}>
        <Grid container spacing={3}>
          <Grid item xs={12} className='card_section card_section--reverse'>
            <div className='card_section-title'>{getDetail(institution_name)}</div>
            <div className='card_section-detail'>{getDetail(institution_type)}</div>
          </Grid>
          <Grid item xs={4}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Address</div>
              <div className='card_section-detail'><RenderHTML html={getDetail(address)} /></div>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Corporate Phone(s)</div>
              <div className='card_section-detail'><RenderHTML html={getDetail(phones)} /></div>
            </div>
          </Grid>
          <Grid item xs={5}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Corporate Email</div>
              <div className='card_section-detail'>{getDetail(email)}</div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Title</div>
              <div className='card_section-detail'>{getDetail(title)}</div>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Function(s)</div>
              <div className='card_section-detail card_section-detail--multiline'>
                {(job && functions && Array.isArray(functions) && functions.length)
                  ? (functions).map((item, index) => (
                    <p key={index}>{item}</p>)
                  ) : '-'}
              </div>
            </div>
          </Grid>
          <Grid item xs={5}>
            <div className='card_section'>
              <div className='card_section-subtitle'>Coverage/Strategy</div>
              <div className='card_section-detail card_section-detail--multiline'>{getStrategy(strategy)}</div>
            </div>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  )
}

export default JobDetail